export type AuthLogoutOptions = {
  redirect?: boolean;
  voluntary?: boolean;
};

type AuthLogoutHandler = (options?: AuthLogoutOptions) => void;

let logoutHandler: AuthLogoutHandler | null = null;

export function registerAuthLogoutHandler(handler: AuthLogoutHandler | null) {
  logoutHandler = handler;
}

export function triggerAuthLogout(options?: AuthLogoutOptions) {
  logoutHandler?.(options);
}

export function redirectToLogin() {
  const base = process.env.PUBLIC_URL || '';
  window.location.href = `${base}/auth/login`;
}
